var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#C1272D;}\n\t.st3{fill:#383E4B;}\n\t.st4{fill:#36A9E1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Bg",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M475,25v450H25V25H475 M500,0H0v500h500V0L500,0z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    className: "st3",
    width: 450,
    height: 450
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M213,337.5v-100c0-6.9-5.6-12.5-12.5-12.5h0c-6.9,0-12.5,5.6-12.5,12.5v100c0,6.9,5.6,12.5,12.5,12.5h0 C207.4,350,213,344.4,213,337.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163,337.5v-50c0-6.9-5.6-12.5-12.5-12.5h0c-6.9,0-12.5,5.6-12.5,12.5v50c0,6.9,5.6,12.5,12.5,12.5h0 C157.4,350,163,344.4,163,337.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M313,337.5v-125c0-6.9-5.6-12.5-12.5-12.5l0,0c-6.9,0-12.5,5.6-12.5,12.5v125c0,6.9,5.6,12.5,12.5,12.5l0,0 C307.4,350,313,344.4,313,337.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M363,337.5v-75c0-6.9-5.6-12.5-12.5-12.5l0,0c-6.9,0-12.5,5.6-12.5,12.5v75c0,6.9,5.6,12.5,12.5,12.5l0,0 C357.4,350,363,344.4,363,337.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M391.4,108.6c18.4,18.4,32.8,39.8,42.9,63.6c7.3,17.4,12.1,35.5,14.3,54.2c0.7,6.3,6,11.2,12.4,11.2l0,0 c7.4,0,13.3-6.5,12.4-13.9c-12-103.2-93.9-185.1-197.1-197.1c-7.4-0.9-13.9,5-13.9,12.4v0c0,6.4,4.8,11.7,11.2,12.4 c18.7,2.2,36.8,7,54.2,14.3C351.7,75.8,373,90.2,391.4,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M434.3,327.8c-7,16.6-16.2,32-27.3,46c-3.9,4.9-3.4,12,1,16.5l0,0c5.3,5.3,14,4.8,18.6-1 c25.1-31.8,41.8-70.6,46.8-112.9c0.9-7.4-4.9-13.9-12.4-13.9h0c-6.4,0-11.7,4.8-12.4,11.1C446.4,292.3,441.6,310.5,434.3,327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M327.8,434.3c-20.8,8.8-42.7,13.9-65.3,15.3c-4.1,0.3-8.3,0.4-12.5,0.4s-8.4-0.1-12.5-0.4 c-22.6-1.4-44.5-6.5-65.3-15.3c-23.8-10.1-45.2-24.5-63.6-42.9c-18.4-18.4-32.8-39.8-42.9-63.6C55.3,303.2,50,277,50,250 s5.3-53.2,15.7-77.8c10.1-23.8,24.5-45.2,42.9-63.6c18.4-18.4,39.8-32.8,63.6-42.9c17.4-7.4,35.5-12.1,54.2-14.3 c6.3-0.7,11.1-6,11.1-12.4v0c0-7.4-6.5-13.3-13.9-12.4C111.8,39.6,25,134.7,25,250c0,120.1,94.1,218.2,212.5,224.6 c4.1,0.2,8.3,0.4,12.5,0.4s8.4-0.1,12.5-0.4c47.8-2.6,91.6-20.1,126.8-48c5.8-4.6,6.3-13.3,1-18.6v0c-4.5-4.5-11.6-4.9-16.5-1 C359.8,418.1,344.4,427.3,327.8,434.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M250,350L250,350c6.9,0,12.5-5.6,12.5-12.5v-175c0-6.9-5.6-12.5-12.5-12.5h0c-6.9,0-12.5,5.6-12.5,12.5v175 C237.5,344.4,243.1,350,250,350z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBDashboard);
export default __webpack_public_path__ + "static/media/B_Dashboard.46b48c4395251bd3b3b93ec8cfd478a5.svg";
export { ForwardRef as ReactComponent };